import script from "./SliderProductHomepage.vue?vue&type=script&setup=true&lang=js"
export * from "./SliderProductHomepage.vue?vue&type=script&setup=true&lang=js"

import "./SliderProductHomepage.vue?vue&type=style&index=0&id=0f1080b8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f1080b8"]])

export default __exports__